import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Tablev2Component } from '../tablev2/tablev2.component';
import { HttpService } from 'src/app/http.service';
import { HotGameManagementFormComponent } from '../hot-game-management-form/hot-game-management-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-hot-game-management',
  templateUrl: './hot-game-management.component.html',
  styleUrls: ['./hot-game-management.component.scss']
})
export class HotGameManagementComponent implements AfterViewInit {

  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef, private ngbModal: NgbModal) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
   }

   ngAfterViewInit(): void {
    this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/app/hot-game/get", data: {uuid: this.company_uuid}},
          disabled_pagenat: true,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Platform', type: 'string', key: 'platform'}, 
            {label: 'Title', type: 'string', key: 'title'}, 
            {label: 'Type', type: 'string', key: 'type'}
          ]}
      this.tb.init(setting);
      this.cdr.detectChanges();
  }

  manageHotGame() {
    let modal = this.ngbModal.open(HotGameManagementFormComponent);
    modal.componentInstance.company_uuid = this.company_uuid;
    modal.componentInstance.closeEvent.subscribe(val => {
      modal.close();
      this.init();
    });
  }
}
